import { useTheme } from "next-themes";
import { ImgHTMLAttributes } from "react";

const visaCardImageURL = "/Assets/visawhite.svg";
const discoverCardImageURL = "/Assets/discoverCardImage.png";
const masterCardImageURL = "/Assets/masterCardIcon.svg";
const mirCardIcon = "/Assets/mirCardIcon.svg";
const alipayIcon = "/Assets/alipayIcon.svg";
const kakaopayIcon = "/Assets/kakaopayIcon.svg";
const sbpIcon = "/Assets/sbpIcon.svg";
const wechatPayIcon = "/Assets/wechatPayIcon.svg";
const gcashLogo = "/Assets/gcashLogo.png";
const paymayaLogo = "/Assets/paymayaLogo.png";
const sberpayIcon = "/Assets/sberpayIcon.svg";
const tbankIcon = "/Assets/tbankIcon.svg";
const yoomoneyIcon = "/Assets/yoomoneyIcon.svg";
const samsungpayIcon = "/Assets/samsungPay.svg";
const vietqrIcon = "/Assets/VietQR_Logo.svg";
const enetsIcon = "/Assets/enets_sg.svg";
const paynowIcon = "/Assets/paynow_sg.svg";
const stcpayIcon = "/Assets/stcpay_sa.svg";
const applepayIcon = "/Assets/applepay_sa.svg";
const CASHAPP_ICON = "/Assets/cashapp.svg";
const PAYPAL_ICON = "/Assets/paypal.svg";

type CardIconProps = ImgHTMLAttributes<HTMLImageElement> & { brand: string };

const CardIcon = ({ brand, ...props }: CardIconProps) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  switch (brand) {
    case "visa":
      return <img src={visaCardImageURL} alt="Visa Card" {...props} style={{ background: "black" }} />;
    case "master":
      return <img src={masterCardImageURL} alt="MasterCard" {...props} />;
    case "discover":
      return <img src={discoverCardImageURL} alt="MasterCard" {...props} />;
    case "mir":
      return <img src={mirCardIcon} alt="Mir Card" {...props} />;
    case "alipay":
      return <img src={alipayIcon} alt="Alipay" {...props} />;
    case "kakaopay":
      return <img src={kakaopayIcon} alt="KakaoPay" {...props} />;
    case "sbp":
      return <img src={sbpIcon} alt="SBP" {...props} />;
    case "wechatpay":
      return <img src={wechatPayIcon} alt="WechatPay" {...props} style={{ filter: isDark ? "invert(0%)" : "invert(100%)" }} />;
    case "payssion-gcash":
      return <img src={gcashLogo} alt="Gcash" {...props} />;
    case "payssion-paymaya":
      return <img src={paymayaLogo} alt="Paymaya" {...props} />;
    case "sberpay":
    case "payssion-sberpay":
      return <img src={sberpayIcon} alt="SberPay" {...props} />;
    case "tbank":
    case "payssion-tbank":
      return <img src={tbankIcon} alt="T-Bank" {...props} />;
    case "yoomoney":
    case "payssion-yoomoney":
      return <img src={yoomoneyIcon} alt="YooMoney" {...props} />;
    case "payssion-samsungpay":
      return <img src={samsungpayIcon} alt="SamsungPay" {...props} />;
    case "payssion-vietqr":
      return <img src={vietqrIcon} alt="VietQR" {...props} />;
    case "payssion-enets":
      return <img src={enetsIcon} alt="Enets" {...props} />;
    case "payssion-paynow":
      return <img src={paynowIcon} alt="Paynow" {...props} />;
    case "payssion-stcpay":
      return <img src={stcpayIcon} alt="STCPay" {...props} />;
    case "payssion-applepay":
      return <img src={applepayIcon} alt="ApplePay" {...props} />;
    case "cashapp":
      return <img src={CASHAPP_ICON} alt="Cash App" {...props} />;
    case "paypal":
      return <img src={PAYPAL_ICON} alt="PayPal" {...props} />;
    default:
      return null;
  }
};

export default CardIcon;
